<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 197.21"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="28.045"
            cy="61.712"
            r="9.965"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M36.085 40.225c2.441,-6.438 2.719,-13.839 0.835,-22.202 -8.2,-1.092 -14.848,-3.547 -19.943,-7.366 -8.986,7.215 -12.958,22.383 -6.389,36.406 8.322,-3.205 16.821,-5.484 25.497,-6.838z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M91.304 43.459c-19.138,-4.923 -37.549,-5.99 -55.219,-3.234 -8.676,1.354 -17.175,3.633 -25.497,6.838 0.278,0.592 0.555,1.192 0.829,1.8 4.101,3.966 8.776,4.362 15.684,1.496 5.292,-2.196 12.285,-1.498 23.604,-1.775 4.836,-0.118 9.688,0.192 15.402,0.088 4.969,0.099 5.011,0.983 10.549,3.162 4.32,1.699 8.749,0.29 10.972,-2.226 0.858,-1.174 1.618,-2.333 2.289,-3.492 0.509,-0.879 0.975,-1.774 1.387,-2.657z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M36.92 18.023c13.938,1.855 32.361,-0.231 55.269,-6.258 -3.493,-6.01 -10.213,-8.361 -18.742,-7.975 -5.89,-0.04 -12.321,1.713 -19.292,5.257 -7.843,2.336 -13.485,1.677 -19.036,-1.18 -7.73,-2.24 -12.509,-2.803 -18.142,2.79 5.095,3.819 11.743,6.274 19.943,7.366z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M63.239 38.976c-0.197,-4.178 -0.074,-11.97 0.37,-21.419 -10.22,1.318 -19.117,1.474 -26.689,0.466 1.884,8.363 1.606,15.764 -0.835,22.202 8.867,-1.383 17.918,-1.8 27.154,-1.249z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M63.609 17.554c-0.443,9.451 -0.567,17.244 -0.37,21.422 6.939,0.413 13.982,1.372 21.129,2.877 2.303,0.479 4.615,1.014 6.936,1.606 3.202,-6.884 3.581,-14.063 3.292,-24.11 -0.377,-2.987 -1.197,-5.499 -2.402,-7.575 -8.192,2.152 -15.815,3.801 -22.867,4.946 -1.949,0.317 -3.855,0.596 -5.718,0.834z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M11.32 48.767c4.123,4.056 8.818,4.48 15.781,1.592 5.292,-2.196 12.285,-1.498 23.604,-1.775 4.836,-0.118 9.688,0.192 15.402,0.088 4.969,0.099 5.011,0.983 10.549,3.162 4.32,1.699 8.749,0.29 10.972,-2.226 6.593,-9.007 7.342,-17.215 6.968,-30.259 -1.469,-11.642 -9.672,-16.078 -21.149,-15.559 -5.89,-0.04 -12.321,1.713 -19.292,5.257 -7.843,2.336 -13.485,1.677 -19.036,-1.18 -7.73,-2.24 -12.509,-2.803 -18.142,2.79m72.952 35.087c-1.067,33.559 -12.522,63.014 -34.364,88.364 -14.849,17.208 -30.35,17.047 -31.94,-15.934 0.617,-35.49 -5.82,-55.707 -13.037,-71.111 -6.569,-14.023 -2.597,-29.191 6.389,-36.406"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="28.99"
            cy="148.458"
            r="9.965"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
